const facetImageMap = {
  Round: 'https://cdn.shopify.com/s/files/1/0590/7457/6561/files/round.png?v=1761145321',
  Oval: 'https://cdn.shopify.com/s/files/1/0590/7457/6561/files/oval.png?v=1761145316',
  Emerald: 'https://cdn.shopify.com/s/files/1/0590/7457/6561/files/emerald.png?v=1761145316',
  Radiant: 'https://cdn.shopify.com/s/files/1/0590/7457/6561/files/radiant.svg?v=1761145321',
  Princess: 'https://cdn.shopify.com/s/files/1/0590/7457/6561/files/princess.png?v=1761145316',
  Cushion: 'https://cdn.shopify.com/s/files/1/0590/7457/6561/files/cushion.png?v=1761145316',
  Asscher: 'https://cdn.shopify.com/s/files/1/0590/7457/6561/files/asscher.png?v=1761145316',
  Marquise: 'https://cdn.shopify.com/s/files/1/0590/7457/6561/files/marquise.png?v=1761145316',
  Pear: 'https://cdn.shopify.com/s/files/1/0590/7457/6561/files/pear.png?v=1761145316',
  Heart: 'https://cdn.shopify.com/s/files/1/0590/7457/6561/files/heart.png?v=1761145316',
};

const facetColorImage = {
  'Platinum': 'https://cdn.shopify.com/s/files/1/0590/7457/6561/files/platinum.png?v=1736545353',
  'Rose Gold': 'https://cdn.shopify.com/s/files/1/0590/7457/6561/files/rose-gold.png?v=1761145688',
  'White Gold': 'https://cdn.shopify.com/s/files/1/0590/7457/6561/files/white-gold.png?v=1761145688',
  'Yellow Gold': 'https://cdn.shopify.com/s/files/1/0590/7457/6561/files/yellow-gold.png?v=1761145688',
};

function processFacetImages(container, imageMap) {
  const labels = container.querySelectorAll('.ais-RefinementList-label, .ais-facet--label');
  console.log('Processing labels:', labels.length);

  labels.forEach(label => {
    if (label.dataset.imageProcessed === 'true') return;
    const text = label.textContent.trim();

    Object.keys(imageMap).forEach(key => {
      if (text.includes(key)) {
        console.log('Match found for:', key);

        const img = document.createElement('img');
        img.src = imageMap[key];
        img.alt = key;
        img.width = 45;
        img.height = 45;
        img.style.verticalAlign = 'middle';

        Array.from(label.childNodes).forEach(node => {
          if (node.nodeType === Node.TEXT_NODE && node.textContent.includes(key)) {
            node.textContent = '';
          }
        });

        const checkbox = label.querySelector('input[type="checkbox"]');
        if (checkbox) {
          checkbox.after(img);
        } else {
          label.insertBefore(img, label.firstChild);
        }

        label.dataset.imageProcessed = 'true';
      }
    });
  });
}

function waitForElement(selector, callback) {
  const element = document.querySelector(selector);
  if (element) {
    callback(element);
  } else {
    setTimeout(() => waitForElement(selector, callback), 100);
  }
}

// Handle Shape Facet (Style)
waitForElement('.ais-facet-options\\.style', (container) => {
  console.log('Shape facet container found!');
  processFacetImages(container, facetImageMap);
  const observer = new MutationObserver(() => processFacetImages(container, facetImageMap));
  observer.observe(container, { childList: true, subtree: true });
});

// Handle Color Facet
waitForElement('.ais-facet-options\\.color-container', (container) => {
  console.log('Color facet container found!');
  processFacetImages(container, facetColorImage);
  const observer = new MutationObserver(() => processFacetImages(container, facetColorImage));
  observer.observe(container, { childList: true, subtree: true });
});
